/**
 * 性能优化工具函数
 */

export function debounce(fn, delay = 300) {
  let timer = null
  return function(...args) {
    if (timer) clearTimeout(timer)
    timer = setTimeout(() => {
      fn.apply(this, args)
    }, delay)
  }
}

export function throttle(fn, interval = 300) {
  let last = 0
  let timer = null
  return function(...args) {
    const now = Date.now()
    if (now - last >= interval) {
      last = now
      fn.apply(this, args)
    } else {
      if (timer) clearTimeout(timer)
      timer = setTimeout(() => {
        last = Date.now()
        fn.apply(this, args)
      }, interval - (now - last))
    }
  }
}

export function rafThrottle(fn) {
  let locked = false
  return function(...args) {
    if (locked) return
    locked = true
    requestAnimationFrame(() => {
      fn.apply(this, args)
      locked = false
    })
  }
}

let performanceData = {
  pageLoadTime: 0,
  apiRequests: [],
  errors: []
}

export function recordPageLoad() {
  performanceData.pageLoadTime = Date.now()
}

export function recordApiRequest(url, startTime, endTime, success) {
  performanceData.apiRequests.push({
    url,
    duration: endTime - startTime,
    success,
    timestamp: new Date().toISOString()
  })
}

export function recordError(error, context = '') {
  performanceData.errors.push({
    error: error.message || String(error),
    context,
    timestamp: new Date().toISOString()
  })
}

export function getPerformanceData() {
  return { ...performanceData }
}

export function clearPerformanceData() {
  performanceData = {
    pageLoadTime: 0,
    apiRequests: [],
    errors: []
  }
}

let memoryCache = new Map()
const CACHE_MAX_SIZE = 100

export function setCache(key, value, ttl = 5 * 60 * 1000) {
  if (memoryCache.size >= CACHE_MAX_SIZE) {
    const firstKey = memoryCache.keys().next().value
    memoryCache.delete(firstKey)
  }
  memoryCache.set(key, {
    value,
    expireAt: Date.now() + ttl
  })
}

export function getCache(key) {
  const item = memoryCache.get(key)
  if (!item) return null
  if (Date.now() > item.expireAt) {
    memoryCache.delete(key)
    return null
  }
  return item.value
}

export function clearCache() {
  memoryCache.clear()
}

export function preloadImage(url) {
  return new Promise((resolve, reject) => {
    const img = new Image()
    img.onload = () => resolve(img)
    img.onerror = reject
    img.src = url
  })
}

export function lazyLoadImage(el, src) {
  if ('IntersectionObserver' in window) {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.src = src
          observer.unobserve(entry.target)
        }
      })
    })
    observer.observe(el)
  } else {
    el.src = src
  }
}
